import React from "react";
import PageSeo from "components/Seo/PageSeo";
import { useSelector } from "react-redux";
import PageHero from "components/PageHero/PageHero";
import StaffMemberCard from "components/StaffPage/StaffMemberCard";
import defaultStaffPhoto from "assets/defaultStaffPhoto.jpeg";
import "components/Home/homeShared.css";
import "./staff.css";

const Staff = () => {
  const staff = useSelector((state) => state.contentfulReducer.staff);

  const visibleStaff = staff.filter((member) => member.fields.display);

  return (
    <main className="staff-page">
      <PageSeo
        title="Our Coaching Staff"
        description="Meet the Ace Gymnastics coaching team in Bardstown, KY — passionate, professional staff for recreational classes and competitive teams."
        path="/staff"
      />

      <PageHero
        title="Our Team"
        subtitle="Passionate coaches and staff dedicated to helping every athlete grow with confidence."
        imageAlt="Ace Gymnastics coaching team in Bardstown, Kentucky"
      />

      <section className="staff-page__content home-section" aria-label="Staff members">
        <div className="home-section__inner">
          {visibleStaff.length === 0 ? (
            <p className="staff-page__empty">Our team profiles are loading. Please check back shortly.</p>
          ) : (
            <div className="staff-page__grid">
              {visibleStaff.map((member) => (
                <StaffMemberCard
                  key={member.fields.name}
                  name={member.fields.name}
                  position={member.fields.jobTitle}
                  photo={
                    member.fields.staffPhoto?.fields?.file?.url ||
                    defaultStaffPhoto
                  }
                  bio={member.fields.bio}
                />
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Staff;
